var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 332.78 288.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M85.33,197.74l-73.7-163h36L90.21,127.3l42.31-92.54h36l-73.47,163Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.69,34.76l76.95,163h-36l-46.5-99-50.45,99H144.15l83-163Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.24,271.51a10.26,10.26,0,0,1-4.16,4A14.07,14.07,0,0,1,37.19,277a16.51,16.51,0,0,1-7.09-1.45,12.58,12.58,0,0,1-5-4A11.26,11.26,0,0,1,23,265.82h5.52a7.84,7.84,0,0,0,4,6A8.9,8.9,0,0,0,37,272.88a7.08,7.08,0,0,0,5.24-1.83,6.32,6.32,0,0,0,1.82-4.66,6,6,0,0,0-1.28-4A9.14,9.14,0,0,0,39.64,260a43.75,43.75,0,0,0-5.12-1.91,50.09,50.09,0,0,1-6.12-2.36,10.42,10.42,0,0,1-3.93-3.33,9.64,9.64,0,0,1-1.63-5.86A10.21,10.21,0,0,1,24.35,241a10,10,0,0,1,4.33-3.7A15.65,15.65,0,0,1,35.31,236q5.92,0,9.4,2.88a11,11,0,0,1,4,7.31H43.17A7.54,7.54,0,0,0,40.72,242a7.73,7.73,0,0,0-5.41-1.82,7.4,7.4,0,0,0-5,1.62,5.73,5.73,0,0,0-1.88,4.58,5.66,5.66,0,0,0,1.23,3.79,8.46,8.46,0,0,0,3,2.28,49.35,49.35,0,0,0,5,1.85,50.38,50.38,0,0,1,6.24,2.39,10.61,10.61,0,0,1,4,3.44,10.31,10.31,0,0,1,1.65,6.12A10.7,10.7,0,0,1,48.24,271.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,238.6a18.76,18.76,0,0,1,7,7.32,23.29,23.29,0,0,1,0,21.23,18.76,18.76,0,0,1-7,7.32,19.5,19.5,0,0,1-10,2.62,19.79,19.79,0,0,1-10.11-2.62,18.56,18.56,0,0,1-7.09-7.32,23.29,23.29,0,0,1,0-21.23,18.56,18.56,0,0,1,7.09-7.32A19.89,19.89,0,0,1,74.94,236,19.59,19.59,0,0,1,85,238.6Zm-17.48,4.13a13.18,13.18,0,0,0-5.13,5.47,19.66,19.66,0,0,0,0,16.65,13.17,13.17,0,0,0,5.13,5.49,14.5,14.5,0,0,0,7.43,1.91,14.21,14.21,0,0,0,7.37-1.94,13.39,13.39,0,0,0,5.12-5.49,19.59,19.59,0,0,0,0-16.62,13.15,13.15,0,0,0-5.12-5.47,15.29,15.29,0,0,0-14.8,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.76,272.59H121v4H101.58V236.5h5.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.18,236.5v24.08c0,3.95.88,6.86,2.62,8.74a9.39,9.39,0,0,0,7.23,2.82,9.08,9.08,0,0,0,7.12-2.85q2.57-2.85,2.56-8.71V236.5h5.18v24.08q0,8.19-4.07,12.32T140.92,277q-6.78,0-10.85-4.13T126,260.58V236.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.51,236.5v4.21H177.18v35.92H172V240.71H160.67V236.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.82,236.5v40.13h-5.18V236.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.57,238.6a18.69,18.69,0,0,1,7,7.32,23.29,23.29,0,0,1,0,21.23,18.69,18.69,0,0,1-7,7.32,19.47,19.47,0,0,1-10,2.62,19.79,19.79,0,0,1-10.11-2.62,18.54,18.54,0,0,1-7.08-7.32,23.21,23.21,0,0,1,0-21.23,18.54,18.54,0,0,1,7.08-7.32A19.89,19.89,0,0,1,225.52,236,19.57,19.57,0,0,1,235.57,238.6Zm-17.48,4.13A13.15,13.15,0,0,0,213,248.2a19.66,19.66,0,0,0,0,16.65,13.15,13.15,0,0,0,5.12,5.49,14.5,14.5,0,0,0,7.43,1.91,14.21,14.21,0,0,0,7.37-1.94,13.48,13.48,0,0,0,5.13-5.49,19.59,19.59,0,0,0,0-16.62,13.24,13.24,0,0,0-5.13-5.47,15.29,15.29,0,0,0-14.8,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.36,276.63h-5.18l-20.84-31.71v31.71h-5.18V236.5h5.18l20.84,31.76V236.5h5.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.7,271.51a10.26,10.26,0,0,1-4.16,4,14,14,0,0,1-6.89,1.54,16.47,16.47,0,0,1-7.08-1.45,12.69,12.69,0,0,1-5-4,11.26,11.26,0,0,1-2.13-5.77H296a7.84,7.84,0,0,0,4,6,9,9,0,0,0,4.47,1.06,7.06,7.06,0,0,0,5.24-1.83,6.28,6.28,0,0,0,1.82-4.66,6,6,0,0,0-1.28-4A9.14,9.14,0,0,0,307.1,260a43.75,43.75,0,0,0-5.12-1.91,51.41,51.41,0,0,1-6.12-2.36,10.42,10.42,0,0,1-3.93-3.33,9.71,9.71,0,0,1-1.62-5.86,10.13,10.13,0,0,1,1.51-5.53,9.9,9.9,0,0,1,4.32-3.7,15.67,15.67,0,0,1,6.64-1.31q5.91,0,9.39,2.88a11,11,0,0,1,4,7.31h-5.58a7.54,7.54,0,0,0-2.45-4.21,7.72,7.72,0,0,0-5.4-1.82,7.4,7.4,0,0,0-5,1.62,6.51,6.51,0,0,0-.66,8.37,8.5,8.5,0,0,0,3.05,2.28,47.58,47.58,0,0,0,5,1.85,49.54,49.54,0,0,1,6.23,2.39,10.54,10.54,0,0,1,4,3.44,10.31,10.31,0,0,1,1.66,6.12A10.71,10.71,0,0,1,315.7,271.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.03,
    y: 213.5,
    width: 312.83,
    height: 9.02,
    rx: 2.38,
    ry: 2.38,
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.dcceace16eb7bbe6ec4b4781f951ec8a.svg";
export { ForwardRef as ReactComponent };